export const initialProductData = {
  category: "",
  name: "",
  slogan: "BUSINESS BASICS",
  photo: "",
  rating: 5,
  starting_quantity: null,
  starting_price: null,
  intro_photo: "https://res.cloudinary.com/dhhn4nlmq/image/upload/v1692375262/business-card_ekguoz.png",
  short_description: "Your name, your business, and every detail you need on high quality card stock. Even if it is the most basic business tool, there's a reason they're still around after 500 years",
  perfect_for: [
    "Good first impressions",
    "Making connections",
    "Impressing your date"
  ],
  cover_photo: [],
  information: "",
  options: [
    {
      title: "Upload your design",
      description: "Click here to select your product options and to upload your print-ready artwork."
    }
  ],
  artwork: {
    instruction: "",
    content: [
      {
        title: "",
        description: ""
      }
    ]
  },
  templates: {
    instruction: "",
    content: [
      {
        format: "",
        pdf: "",
        image: ""
      }
    ]
  },
  faq: {
    instruction: "",
    content: [
      {
        question: "",
        answer: ""
      }
    ]
  },
  design_services: [
    {
      title: "",
      price: null,
      services: [
          {content: ""}
      ]
    }
  ],
  intro: [
    {
      placeholder: "",
      value: [
        {
          photo: "",
          title: "",
          features: [""]
        },
      ],
    }
  ],
  ideas: [
    {
      title: "",
      photo: ""
    }
  ],
  pricing: [],
 
};
